import { trainersApi } from "api";
import { useTrainerGroup } from "api/hooks";
import { PaziaBreadcrumbs } from "components/atoms";
import { routes } from "consts";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TrainerGroupForm, TrainerGroupFormValues } from "./TrainerGroupForm/TrainerGroupForm";

export const TrainerGroupEditPage = (): JSX.Element | null => {
  const { trainerGroupId } = useParams();
  const navigate = useNavigate();
  const { loading, data } = useTrainerGroup(Number(trainerGroupId));

  if (loading || data === null) return null;

  const breadcrumbs = [{ title: "Grupy trenerow", path: routes.TRAINERS_GROUPS }, { title: data.name }];

  const onSubmit = (data: TrainerGroupFormValues) => {
    trainersApi.createGroup(data).then(() => navigate(routes.TRAINERS_GROUPS));
  };

  return (
    <main className="grow">
      <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
        <PaziaBreadcrumbs segments={breadcrumbs} className="mb-8" />
        <TrainerGroupForm {...data} onSubmit={onSubmit} />
      </div>
    </main>
  );
};
